import React, { useState } from "react";
import classes from "./styles/style.module.css";
import ButtonShape from "../../assets/images/rb/rb-button-header.png";
import { useNavigate } from "react-router";
import VideoPlayer from "../../assets/components/VideoPlayer";

const RBMenuElement = ({ item, noMargin }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = (link) => {
    if (link !== "#") {
      if (link.includes("http")) {
        window.open(link, "_blank");
      } else {
        navigate(link);
      }
    }
    if (item.video) {
      setIsOpen(true);
    }
  };

  return (
    <>
      <div
        className={`${classes.menuItem} ${noMargin ? classes.noMargin : ""}`}
        onClick={() => handleClick(item.link)}
      >
        <div className={classes.menuElementShape}>
          <img src={ButtonShape} alt="button-header" />
        </div>
        <span
          dangerouslySetInnerHTML={{ __html: item.text }}
          className={` ${
            item.link === "#" && !item.video ? classes.disabled : ""
          }`}
        ></span>
      </div>
      {isOpen && (
        <VideoPlayer
          open={true}
          closeHandler={() => setIsOpen(false)}
          videoUrl={item.video}
        />
      )}
    </>
  );
};

export default RBMenuElement;
